module.exports = __webpack_public_path__ + "img/image65.ffb0fd42.jpg";